<template>
  <div class="map-container">
    <Map />
  </div>
</template>
<script>

import Map from '@/components/common/Map';

export default {
  components: {
    Map,
  },
};
</script>
<style>
.map-container {
  position: relative;
  width: 100%;
  height: 450px;
}
</style>
